module.exports = __webpack_public_path__ + "img/ms_azure.4c16da61.webp";